/**
 * SongsPicker — §04 Significado, empty state.
 *
 * Three song cards. Click one to open the single-song stage.
 *
 * Pattern mirrors the iter02 prototype's `dd-handoff` block (renamed under
 * the `sm-` namespace because this picker is the section's own resting
 * state, not a deep-dive bridge). Cards are <button> elements driving
 * `Songs.tsx`'s `index` state — there is no #songs anchor anymore.
 *
 * Reveal granularity (per scroll-driven reveal audit, Option A):
 * - Eyebrow is its own Reveal.
 * - Each card is its own Reveal so the three picker cards animate in
 *   sequence as the visitor scrolls into §04, instead of popping in
 *   together as a single block.
 */

import { Reveal } from '../primitives/Reveal';
import type { SongMeaning } from '@/types/album';

interface SongsPickerProps {
  songs: readonly SongMeaning[];
  onPick: (index: number) => void;
}

export function SongsPicker({ songs, onPick }: SongsPickerProps): JSX.Element {
  return (
    <div className="sm-picker" aria-label="Elegir una canción">
      <Reveal as="div" className="sm-picker-eyebrow">
        — Tres canciones · una a la vez
      </Reveal>
      <div className="sm-picker-grid">
        {songs.map((s, i) => (
          <Reveal
            as="button"
            key={s.n}
            type="button"
            className="sm-picker-card"
            onClick={() => onPick(i)}
            aria-label={`Leer el significado de ${s.title}`}
          >
            <span className="num">{String(i + 1).padStart(2, '0')}</span>
            <span className="title">{s.title}</span>
            <span className="cue">
              Leer significado{' '}
              <span aria-hidden="true">→</span>
            </span>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
